@if (!hideAll()) {
  @if (!inviteMode()) {
    @if (isDesktop()) {
      <app-dialog-mode-switcher
        location="share-gallery-dialog"
        [modes]="$any(menuItems)"
        [(mode)]="mode"
      ></app-dialog-mode-switcher>
    }
  } @else {
    @if (isDesktop()) {
      @if (inviteMode() === 'email') {
        <button
          (click)="collaborators.cancelInvite()"
          color="simple-gray"
          appButton
          name="cancel-invite"
          location="share-gallery-dialog"
          shape="round"
          [iconButton]="true"
          spacing="1"
          data-test-id="close-dialog-button"
          height="1"
          shape="round"
          class="close-button"
        >
          <app-svg src="/assets/icons/cross.svg"></app-svg>
        </button>
      } @else if (inviteMode() === 'choice') {
        <button
          (click)="collaborators.cancelInviteChoice()"
          color="simple-gray"
          appButton
          name="cancel-invite-choice"
          location="share-gallery-dialog"
          shape="round"
          [iconButton]="true"
          spacing="1"
          data-test-id="close-dialog-button"
          height="1"
          class="close-button"
        >
          <app-svg src="/assets/icons/cross.svg"></app-svg>
        </button>
      }
    } @else {
      <div class="mobile-link-header">
        <button
          appButton
          name="back"
          location="share-gallery-dialog"
          color="simple"
          shape="round"
          [iconButton]="true"
          height="1"
          (click)="inviteMode() === 'choice' ? collaborators.cancelInviteChoice() : collaborators.cancelInvite()"
        >
          <app-svg src="/assets/icons/arrow-left.svg"></app-svg>
        </button>
        <h2>Invite Collaborator</h2>
      </div>
    }
  }
  <div class="main-container">
    @if (mode() === 'collaborators') {
      <app-share-gallery-collaborators
        [item]="gallery()"
        [isDesktop]="isDesktop()"
        #collaborators
        (onChangeInviteMode)="inviteMode.set($event)"
      ></app-share-gallery-collaborators>

      @if (!isDesktop() && !inviteMode()) {
        <div class="gradient-footer">
          <button
            appButton
            name="mobile-share"
            location="share-gallery-dialog"
            color="primary"
            shape="round"
            spacing="full"
            height="3"
            [class.disabled]="gallery().public_access === 'no_access'"
            [share]="shareLink()"
            (onCopied)="shareLinkCopied()"
          >
            Share Link
          </button>

          <button
            appButton
            name="share-link-settings"
            location="share-gallery-dialog"
            shape="round"
            size="1"
            weight="bold"
            color="simple"
            [center]="true"
            [hasIcon]="true"
            (click)="mode.set('link')"
          >
            <span>Link Settings</span>
            <app-svg src="/assets/icons/16/chevron-right.svg" size="-1"></app-svg>
          </button>
        </div>
      }
    } @else if (mode() === 'link') {
      @if (!isDesktop()) {
        <div class="mobile-link-header">
          <button
            appButton
            name="back"
            location="share-gallery-dialog"
            color="simple"
            shape="round"
            [iconButton]="true"
            height="1"
            (click)="mode.set('collaborators')"
          >
            <app-svg src="/assets/icons/arrow-left.svg"></app-svg>
          </button>
          <h2>Link Settings</h2>
        </div>
      }

      <app-share-gallery-link [item]="gallery()" [isDesktop]="isDesktop()"></app-share-gallery-link>
    } @else if (mode() === 'embed') {
      <app-share-gallery-embed [gallery]="gallery()" (onChangeMode)="mode.set($event)"> </app-share-gallery-embed>
    }
  </div>
}
